const eligibilityRules = {
  '4_8': {
    f: [78, 175],
    m: [83, 175]
  },
  '4_9': {
    f: [81, 180],
    m: [86, 180]
  },
  '4_10': {
    f: [84, 185],
    m: [89, 185]
  },
  '4_11': {
    f: [87, 190],
    m: [92, 190]
  },
  '5_0': {
    f: [90, 196],
    m: [95, 196]
  },
  '5_1': {
    f: [93, 202],
    m: [98, 202]
  },
  '5_2': {
    f: [96, 208],
    m: [101, 208]
  },
  '5_3': {
    f: [99, 214],
    m: [104, 214]
  },
  '5_4': {
    f: [102, 220],
    m: [107, 220]
  },
  '5_5': {
    f: [105, 226],
    m: [110, 226]
  },
  '5_6': {
    f: [108, 232],
    m: [113, 232]
  },
  '5_7': {
    f: [111, 238],
    m: [116, 238]
  },
  '5_8': {
    f: [114, 244],
    m: [119, 244]
  },
  '5_9': {
    f: [118, 250],
    m: [123, 250]
  },
  '5_10': {
    f: [122, 256],
    m: [127, 256]
  },
  '5_11': {
    f: [126, 262],
    m: [131, 262]
  },
  '6_0': {
    f: [130, 269],
    m: [135, 269]
  },
  '6_1': {
    f: [134, 276],
    m: [139, 276]
  },
  '6_2': {
    f: [138, 283],
    m: [143, 283]
  },
  '6_3': {
    f: [143, 290],
    m: [148, 290]
  },
  '6_4': {
    f: [148, 297],
    m: [153, 297]
  },
  '6_5': {
    f: [153, 304],
    m: [158, 304]
  },
  '6_6': {
    f: [158, 311],
    m: [163, 311]
  }
}

export default eligibilityRules
